module.exports = __webpack_public_path__ + "media/images/athletes/1609-cdf399f13c04a77b08f2f63c880fcc51.png";